'use strict'

define [], () ->
  () ->
    restrict: "A"
    link: (scope, element, attrs) ->
      scope.$watch attrs.iframeSrcdoc, (newVal) ->
        if newVal
          element[0].srcdoc = newVal



// WEBPACK FOOTER //
// ./directives/iframeSrcdoc/iframeSrcdoc.coffee